// Author Eric
// Date 2020-09-18 09:17:41

import * as model from "@/model/sithMes/andon/SithMesAndonPositionModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {levelTreePatternFactory} from "@/store/em/commonPattern/levelTreePatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesAndonPosition(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_ANDON_URL,
    })
    .withPatternFactory(levelTreePatternFactory, {
        entity: 'sithMesAndonPosition',
        modelFilter: model.filter
    })
    .buildStore()
